// =============================================================================
// features/sales/campaigns/wizard/components/HygieneCountsGrid.tsx — Grade de
// categorias da higiene (etapa 3, doc 26 §4.2). Cada categoria mostra o
// NÚMERO + o MOTIVO em texto (DoD: "prévia mostra motivo de cada exclusão";
// "restrições comunicadas em texto, não só por cor" — WCAG). Bloqueados tem
// card PRÓPRIO, nunca somado a inválidos (DoD explícito).
// =============================================================================

import type { AudienceCounts } from '@elemento/shared-schemas';
import * as React from 'react';

import { cn } from '../../../../../lib/cn';
import {
  HYGIENE_CATEGORY_LABEL,
  HYGIENE_CATEGORY_MATERIALIZES,
  HYGIENE_CATEGORY_ORDER,
  HYGIENE_CATEGORY_REASON,
} from '../labels';

export interface HygieneCountsGridProps {
  counts: AudienceCounts;
}

export function HygieneCountsGrid({ counts }: HygieneCountsGridProps): React.JSX.Element {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" role="list">
      {HYGIENE_CATEGORY_ORDER.map((key) => {
        const value = counts[key];
        const materializes = HYGIENE_CATEGORY_MATERIALIZES[key];
        return (
          <div
            key={key}
            role="listitem"
            className={cn('rounded-sm border p-4 flex flex-col gap-1.5')}
            style={{
              background: 'var(--surface-1)',
              borderColor: materializes ? 'var(--border-strong)' : 'var(--border)',
              boxShadow: 'var(--elev-1)',
            }}
          >
            <div className="flex items-baseline justify-between gap-2">
              <span className="font-sans text-xs font-bold uppercase tracking-[0.06em] text-ink-3">
                {HYGIENE_CATEGORY_LABEL[key]}
              </span>
              <span
                className="font-mono font-semibold text-ink"
                style={{ fontSize: 'var(--text-lg)' }}
              >
                {value.toLocaleString('pt-BR')}
              </span>
            </div>
            <p className="font-sans text-xs text-ink-3 leading-relaxed">
              {HYGIENE_CATEGORY_REASON[key]}
            </p>
            <span
              className={cn(
                'font-sans text-[0.65rem] font-bold uppercase tracking-[0.04em] mt-1',
                materializes ? 'text-verde' : 'text-ink-4',
              )}
            >
              {materializes ? 'Entra na carteira' : 'Não entra na carteira'}
            </span>
          </div>
        );
      })}
    </div>
  );
}
